import {GET_FCM_HISTORY_START} from "../../types";

export const fcm_history = (payload) => ({
  type: GET_FCM_HISTORY_START,
  payload,
});
